import { CourseProgress, IconName } from "@inductiveautomation/ws-components";
import {
  // Certification,
  ElectiveWithType,
  GetCertificationsResponse,
} from "../Training.types";
// import { history } from "./Training.history.mocks";

// const sortById = (a: Certification, b: Certification) => {
//   if (a.id < b.id) return -1;
//   if (a.id > b.id) return 1;

//   return 0;
// };

const topic = (suffix: string) => ({
  id: `topic-${suffix}`,
  icon: "placeholder" as const,
  name: "[Topic-Name]",
});

export const demoCourseProgress: CourseProgress[] = [
  {
    id: "course-1",
    icon: "course-ignition-basics",
    name: "Ignition Overview",
    completionPercentage: 25,
    topics: [topic("1"), topic("2")],
  },
  {
    id: "course-2",
    icon: "course-ignition-basics",
    name: "Ignition Editions",
    completionPercentage: 0,
    topics: [topic("3"), topic("4"), topic("5")],
  },
  {
    id: "course-3",
    icon: "course-ignition-gateway",
    name: "Ignition Gateway",
    completionPercentage: 10,
    topics: [topic("6")],
  },
  {
    id: "course-4",
    icon: "course-opc-ua-and-devices",
    name: "OPC UA and Devices in Ignition",
    completionPercentage: 100,
    topics: [topic("7"), topic("8")],
  },
  {
    id: "course-5",
    icon: "course-databases",
    name: "Databases in Ignition",
    completionPercentage: 50,
    topics: [topic("9"), topic("10")],
  },
  {
    id: "course-6",
    icon: "course-ignition-gateway",
    name: "Ignition Designer",
    completionPercentage: 58,
    topics: [topic("11"), topic("12"), topic("13"), topic("14")],
  },
];

const demoLabels = [
  "Empty - Nothing earned",
  "Elective Studies",
  "Employee Courses - Empty",
  "Employee Courses",
  "Credential - In progress",
  "Credential - Earned",
  "Credential - Update available",
  "Core - In progress",
  "Core - Earned",
  "Core - Expires soon",
  "Core - Expired",
  "Gold - In progress (in-person training course)",
  "Gold - In progress (online training course)",
  "Gold - In progress (test)",
  "Gold - In progress (failed with pending retry)",
  "Gold - Earned",
  "Gold - Expires soon",
  "Gold - Expired",
  "Gold - Invalid",
];
export const numberOfResponses = demoLabels.length;

export const getDemoState = (index: number) => demoLabels[index];

export const getResponse = (index: number): GetCertificationsResponse => {
  const responses = [
    emptyResponse,
    electiveCoursesResponse,
    electiveCoursesResponse,
    employeeCoursesResponse,
    // credentialInProgressResponse,
    // credentialEarnedResponse,
    // credentialUpdateAvailableResponse,
    // coreInProgressResponse,
    // coreEarnedResponse,
    // coreExpiresSoonResponse,
    // coreExpiredResponse,
    // goldInProgressTrainingInPersonResponse,
    // goldInProgressTrainingOnlineResponse,
    // goldInProgressTestResponse,
    // goldInProgressFailedWithPendingRetryResponse,
    // goldEarnedResponse,
    // goldExpiresSoonResponse,
    // goldExpiredResponse,
    // goldInvalidResponse,
  ];

  return {
    current: responses[index],
    history: [],
    canViewEmployeeCourses: demoLabels[index].startsWith("Employee Courses"),
  };
};

export const emptyResponse: GetCertificationsResponse["current"] = [];

// const certificationsWithout = (
//   response: GetCertificationsResponse["current"],
//   excludedCurrentId: number,
// ) => {
//   return response.filter(
//     (certification) =>
//       certification.id !== `certification-${excludedCurrentId}`,
//   );
// };

// export const credentialInProgressResponse: GetCertificationsResponse["current"] =
//   [
//     ...certificationsWithout(emptyResponse, 1),
//     {
//       id: "certification-1",
//       name: "8.3 IU Credential",
//       type: "CREDENTIAL",
//       status: "IN_PROGRESS",
//       courseProgress: demoCourseProgress,
//     },
//   ];

// export const credentialEarnedResponse: GetCertificationsResponse["current"] = [
//   ...certificationsWithout(emptyResponse, 1),
//   {
//     id: "certification-1",
//     name: "8.3 IU Credential",
//     status: "EARNED",
//     type: "CREDENTIAL",
//     earnedAt: new Date(2024, 6, 11),
//     courseProgress: demoCourseProgress,
//   },
// ];

// export const credentialUpdateAvailableResponse: GetCertificationsResponse["current"] =
//   [
//     ...certificationsWithout(emptyResponse, 1),
//     {
//       id: "certification-1",
//       name: "8.3 IU Credential",
//       status: "UPDATE_AVAILABLE",
//       type: "CREDENTIAL",
//       earnedAt: new Date(2024, 6, 11),
//       courseProgress: demoCourseProgress,
//     },
//   ];

// export const coreInProgressResponse: GetCertificationsResponse["current"] = [
//   ...certificationsWithout(credentialEarnedResponse, 2),
//   {
//     id: "certification-2",
//     name: "Core Certification",
//     type: "CORE",
//     status: "IN_PROGRESS",
//   },
// ];

// export const coreEarnedResponse: GetCertificationsResponse["current"] = [
//   ...certificationsWithout(credentialEarnedResponse, 2),
//   {
//     id: "certification-2",
//     name: "Core Certification",
//     type: "CORE",
//     status: "EARNED",
//     earnedAt: new Date(2024, 6, 11),
//     expiresAt: new Date(2025, 6, 11),
//     earnMethod: "course",
//   },
// ];

// export const coreExpiresSoonResponse: GetCertificationsResponse["current"] = [
//   ...certificationsWithout(credentialEarnedResponse, 2),
//   {
//     id: "certification-2",
//     name: "Core Certification",
//     type: "CORE",
//     status: "EXPIRES_SOON",
//     earnedAt: new Date(2024, 6, 11),
//     expiresAt: new Date(2025, 6, 11),
//     earnMethod: "course",
//   },
// ];

// export const coreExpiredResponse: GetCertificationsResponse["current"] = [
//   ...certificationsWithout(credentialEarnedResponse, 2),
//   {
//     id: "certification-2",
//     name: "Core Certification",
//     type: "CORE",
//     status: "EXPIRED",
//     earnedAt: new Date(2023, 6, 11),
//     expiresAt: new Date(2024, 6, 11),
//     earnMethod: "course",
//   },
// ];

// export const goldInProgressTrainingInPersonResponse: GetCertificationsResponse["current"] =
//   [
//     ...certificationsWithout(coreEarnedResponse, 3),
//     {
//       id: "certification-3",
//       name: "Gold Certification",
//       type: "GOLD",
//       status: "IN_PROGRESS_WITH_TRAINING",
//       trainingType: "IN_PERSON",
//       trainingDate: new Date(2024, 9, 1),
//     },
//   ];

// export const goldInProgressTrainingOnlineResponse: GetCertificationsResponse["current"] =
//   [
//     ...certificationsWithout(coreEarnedResponse, 3),
//     {
//       id: "certification-3",
//       name: "Gold Certification",
//       type: "GOLD",
//       status: "IN_PROGRESS_WITH_TRAINING",
//       trainingType: "ONLINE",
//       trainingDate: new Date(2024, 9, 1),
//     },
//   ];

// export const goldInProgressTestResponse: GetCertificationsResponse["current"] =
//   [
//     ...certificationsWithout(coreEarnedResponse, 3),
//     {
//       id: "certification-3",
//       name: "Gold Certification",
//       type: "GOLD",
//       status: "IN_PROGRESS",
//     },
//   ];

// export const goldInProgressFailedWithPendingRetryResponse: GetCertificationsResponse["current"] =
//   [
//     ...certificationsWithout(coreEarnedResponse, 3),
//     {
//       id: "certification-3",
//       name: "Gold Certification",
//       type: "GOLD",
//       status: "IN_PROGRESS_FAILED_PENDING_RETRY",
//     },
//   ];

// export const goldEarnedResponse: GetCertificationsResponse["current"] = [
//   ...certificationsWithout(coreEarnedResponse, 3),
//   {
//     id: "certification-3",
//     name: "Gold Certification",
//     type: "GOLD",
//     status: "EARNED",
//     earnedAt: new Date(2024, 6, 11),
//     expiresAt: new Date(2025, 6, 11),
//     earnMethod: "test",
//   },
// ];

// export const goldExpiresSoonResponse: GetCertificationsResponse["current"] = [
//   ...certificationsWithout(coreEarnedResponse, 3),
//   {
//     id: "certification-3",
//     name: "Gold Certification",
//     type: "GOLD",
//     status: "EXPIRES_SOON",
//     earnedAt: new Date(2024, 6, 11),
//     expiresAt: new Date(2025, 6, 11),
//     earnMethod: "test",
//   },
// ];

// export const goldExpiredResponse: GetCertificationsResponse["current"] = [
//   ...certificationsWithout(coreEarnedResponse, 2),
//   {
//     id: "certification-2",
//     name: "Core Certification",
//     type: "CORE",
//     status: "EXPIRED",
//     earnedAt: new Date(2023, 6, 11),
//     expiresAt: new Date(2024, 6, 11),
//     earnMethod: "test",
//   },
//   {
//     id: "certification-3",
//     name: "Gold Certification",
//     type: "GOLD",
//     status: "EXPIRED",
//     earnedAt: new Date(2023, 6, 11),
//     expiresAt: new Date(2024, 6, 11),
//     earnMethod: "test",
//   },
// ];

// export const goldInvalidResponse: GetCertificationsResponse["current"] = [
//   ...certificationsWithout(coreEarnedResponse, 2),
//   {
//     id: "certification-3",
//     name: "Gold Certification",
//     type: "GOLD",
//     status: "INVALID",
//     earnedAt: new Date(2024, 6, 11),
//     expiresAt: new Date(2025, 6, 11),
//     earnMethod: "test",
//   },
// ];

const course =
  (type: "ELECTIVE" | "EMPLOYEE") =>
  (id: string, name: string, icon?: IconName, completed = false) => ({
    type,
    id: `${type.toLowerCase()}-${id}`,
    name,
    icon,
    completedAt: completed ? new Date() : undefined,
    status: completed ? ("COMPLETED" as const) : ("IN_PROGRESS" as const),
    courseProgress: [
      {
        id: "course-1",
        icon: "course-placeholder" as const,
        name: "[Course-Name]",
        completionPercentage: 0,
        topics: [topic("1"), topic("2"), topic("3")],
      },
    ],
  });

const elective = course("ELECTIVE");
const mockElectiveStudies: ElectiveWithType[] = [
  elective(
    "1",
    "Building in Perspective",
    "course-building-in-perspective",
    true
  ),
  elective("2", "Design Fundamentals", "course-design-fundamentals", true),
  elective("3", "Advanced Styling in Perspective"),
  elective("4", "Ignition with Docker"),
  elective("5", "Module Development with the Ignition SDK"),
];

const employee = course("EMPLOYEE");
const mockEmployeeCourses: ElectiveWithType[] = [
  employee("1", "Industry, Ignition, and IA 101", "course-ia-101", true),
  employee("2", "Software Tutorials", "course-software-tutorials", true),
  employee("3", "Software Engineering Training"),
  employee("4", "Support Services Training"),
];

export const electiveCoursesResponse: GetCertificationsResponse["current"] = [
  // ...goldEarnedResponse,
  ...mockElectiveStudies,
];

export const employeeCoursesResponse: GetCertificationsResponse["current"] = [
  // ...goldEarnedResponse,
  ...mockElectiveStudies,
  ...mockEmployeeCourses,
];
